// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-side-icon[data-v-0c86e1e8]{display:flex;justify-content:center;align-items:center;height:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
